import { Box, createStyles, Stack } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { RpiTitle, RpiBodyText } from "@rpi/openapi-core";
import React from "react";

const useAuthContainerStyles = createStyles((theme) => ({
  fullColorBackground: {
    position: "relative",
    flex: 1,
    background: [`linear-gradient(285deg, #F4F9FF 15.44%, #CDD8E5 50.3%, #F4F9FF 85.85%)`],
    display: "flex",
    justifyContent: "center",
    color: theme.other.semanticColors.textBold,
  },
  halfColorBackground: {
    position: "relative",
    flex: 1,
    background: [`#E0E9F0`],
    display: "flex",
    justifyContent: "center",
    color: theme.other.semanticColors.textBold,
  },

  mobileContainer: {
    textAlign: "center",
  },
}));

interface AuthContainerProps {
  hideRightPane?: boolean;
  children: React.ReactNode;
}

const ContentWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box
    sx={{
      position: "relative",
      width: "100%",
      padding: "120px 32px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <Box
      sx={{
        width: "100%",
        maxWidth: 520,
      }}
    >
      {children}
    </Box>
  </Box>
);

export const AuthContainer: React.FC<AuthContainerProps> = ({ hideRightPane, children }) => {
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const isMobile = useMediaQuery("(max-width: 767px)");
  const { classes } = useAuthContainerStyles();

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
      }}
    >
      <Box className={hideRightPane ? classes.fullColorBackground : classes.halfColorBackground}>
        <ContentWrapper>
          {isMobile && (
            <Stack spacing="lg" align="center" className={classes.mobileContainer}>
              <img src="/logo.svg" width={94} height={94} alt="RPI Print API Logo" />

              <RpiTitle>RPI Print API</RpiTitle>

              <RpiBodyText>
                This platform is best experienced on a desktop device. <br />
                Please access it from a desktop browser to continue.
              </RpiBodyText>
            </Stack>
          )}

          <Box sx={{ width: "100%", display: isMobile ? "none" : "block" }}>{children}</Box>
        </ContentWrapper>
      </Box>

      {isDesktop && !hideRightPane && (
        <Box
          sx={{
            position: "sticky",
            top: 0,
            flex: 1,
            height: "100vh",
            backgroundImage: "url('/auth-bg.webp')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></Box>
      )}
    </Box>
  );
};
